import React, { useState, useEffect } from 'react'
import './style.css'
import Select from 'react-select';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux';
import { professionalDeleteService, ProfessionalServicesAPI, ProfessionalServicesShowAPI, ProfessionalServiceUpdateAPI } from '../../redux/slices/ProfessionalServcicesSlice';
import { useFormik } from 'formik';
import { corporateAddEmployeeValidationSchema } from '../../schemas/corporateaddemployevalidaionschema';
import { corporateAddEmployeeAPI, corporateShowEmployeesAPI } from '../../redux/slices/CorporateAddEmployee';
import DashboardLayout from '../../pages/corporate/dashboard/DashboardLayout';
import { useNavigate } from 'react-router-dom';
import GoogelMapAPI from '../GoogelMapAPI/GoogelMapAPI';
import { errorHandler, services } from '../../constants/base';

const AddEmploye = ({ setAcitveEmploye }) => {

    const [getLocationAttributes, setGetLocationAttributes] = useState({})

    const [addressData, setAddressData] = useState({
        address: getLocationAttributes?.address || '',
        longitude: getLocationAttributes?.longitude || '',
        latitude: getLocationAttributes?.latitude || '',
    });

    useEffect(() => {
        if (getLocationAttributes) {
            setAddressData({
                address: getLocationAttributes.address || '',
                longitude: getLocationAttributes.longitude || '',
                latitude: getLocationAttributes.latitude || '',
            });
        }
    }, [getLocationAttributes]);

    const user = useSelector((state) => state?.AuthSlice?.user);
    const dispatch = useDispatch();
    const [deletedId, setDeletedId] = useState("")
    const loading = useSelector(state => state?.ProfessionalAddServicesSlice?.loading)
    const Employeeloading = useSelector(state => state?.coporateAddEmployeSlice?.loading)
    const showLoading = useSelector(state => state.ProfessionalAddServicesSlice.showLoading)
    const allServices = useSelector(state => state?.ProfessionalAddServicesSlice?.services)
    const deleteLoading = useSelector(state => state.ProfessionalAddServicesSlice.deleteLoading)

    const navigate = useNavigate()

    ///////////////////////////////////SERVICES FORM LOGIC HERE/////////////////////////////////////////////

    // State to hold form data
    const [formData, setFormData] = useState({
        name: "",
        currency: "USD",
        price: "",
        user_id: "",
        corporate_id: user?.id
    });

    const isFormValid = () => {
        return formData.name && formData.price;
    };

    const [formArray, setFormArray] = useState([]);

    // Handle form submission
    const handleServicesSubmit = async (e) => {
        e.preventDefault();
        setFormArray((prevArray) => [...prevArray, formData]);
        const closeButton = document.querySelector("#close-btn-services");
        if (closeButton) {
            closeButton.click();
        }
        setFormData({
            name: "",
            currency: "USD",
            price: "",
            user_id: "",
            corporate_id: user?.id
        });
    };

    // Handle change for select inputs and number input
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleEditService = (itemId) => {
        const selectedItem = allServices.find((item) => item.id === itemId);
        if (selectedItem) {
            setFormData({
                ...selectedItem,
            });
            const modal = new window.bootstrap.Modal(document.getElementById('exampleModalToggle2'));
            modal.show();
        }
    };

    const handleUpdate = async (e) => {
        e.preventDefault()
        const res = await dispatch(ProfessionalServiceUpdateAPI(formData))
        await dispatch(ProfessionalServicesShowAPI(user?.id));

        if (res?.payload?.status === 200) {
            toast.success("Service Update Successfully")
            const closeButton = document.querySelector("#close-btn-services-2");
            if (closeButton) {
                closeButton.click();
            }
        }

        if (ProfessionalServiceUpdateAPI.fulfilled(res)) {
            if (res.payload.success || res.payload.status === 200) {
                toast.success('Profile updated successfully!');
            } else {
                errorHandler(res.payload.errors);
            }
        } else if (ProfessionalServiceUpdateAPI.rejected(res)) {
            errorHandler(res.payload.errors);
        } else {
            toast.error('Sorry, something went wrong!');
        }

        setFormData({
            user_id: user?.id,
            name: "",
            currency: "",
            price: "",
        });
    }

    // const handleDeleteService = async (id) => {
    //     // const res = await dispatch(professionalDeleteService(id))
    //     // await dispatch(ProfessionalServicesShowAPI(user?.id));
    //     // setDeletedId("");
    //     // if (res?.payload?.status === 200) {
    //     //     toast.success("Service Deleted Successfully")
    //     //     const closeButton = document.querySelector("#close-btn-update-model-3");
    //     //     if (closeButton) {
    //     //         closeButton.click();
    //     //     }
    //     // }
    //     // setFormData({
    //     //     user_id: user?.id,
    //     //     name: "",
    //     //     currency: "",
    //     //     price: "",
    //     // });
    // }

    const handleDeleteService = async (index) => {
        setFormArray((prevArray) => prevArray.filter((_, i) => i !== index));
    };

    ///////////////////////////////////SERVICES FORM LOGIC HERE/////////////////////////////////////////////

    ///////////////////////////////////ADD EMPLOYEE FORM LOGIC HERE/////////////////////////////////////////

    const [passwordVisible, setPasswordVisible] = useState(false);
    const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };

    const toggleConfirmPasswordVisibility = () => {
        setConfirmPasswordVisible(!confirmPasswordVisible);
    };

    const [imagePreview, setImagePreview] = useState(null);

    const handleImageChange = (e) => {
        const file = e.currentTarget.files[0];
        const reader = new FileReader();
        reader.onloadend = () => {
            setImagePreview(reader.result);
        };
        if (file) {
            reader.readAsDataURL(file);
        }
        formik.setFieldValue('profile', file);
    };

    const [initialValues, setInitialValues] = useState(null);

    useEffect(() => {
        if (allServices) {
            setInitialValues({
                name: "",
                phone_no: "",
                ss_number: "",
                email: "",
                password: "",
                confirm_password: "",
                about: "",
                address: addressData?.address || "",
                longitude: addressData?.longitude || "",
                latitude: addressData?.latitude || "",
                profile: null,
                other: null,
            });
        }
    }, [allServices]);

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: corporateAddEmployeeValidationSchema,
        enableReinitialize: true,
        onSubmit: async (values) => {
            const formData = new FormData();
            Object.keys(values).forEach((key) => {
                if (key === "profile" || key === "other") {
                    if (values[key]) {
                        formData.append(key, values[key]);
                    }
                } else if (key === "services") {
                    formData.append(key, JSON.stringify(values[key]));
                } else {
                    formData.append(key, values[key]);
                }
            });
            Object.keys(addressData).forEach((key) => {
                formData.append(key, addressData[key]);
            });
            formData.append("id", user?.id);

            if (addressData?.longitude) {
                formData.append("longitude", addressData.longitude);
            }
            if (addressData?.latitude) {
                formData.append("latitude", addressData.latitude);
            }
            if (addressData?.address) {
                formData.append("address", addressData.address);
            }

            const res = await dispatch(corporateAddEmployeeAPI(formData));

            if (res.type === 'corporateAddEmployeeAPI/fulfilled') {
                if (res.payload.success || res.payload.status || res.payload.data.status === 200) {
                    toast.success("Employee Added Successfully");
                } else {
                    errorHandler(res.payload.errors);
                }

                const employee_id = res?.payload?.data?.data?.id;
                const promises = formArray.map(async (item) => {
                    item["user_id"] = employee_id;
                    return await dispatch(ProfessionalServicesAPI(item));
                });
                await Promise.all(promises);
                navigate('/corporate/employees');
                await dispatch(corporateShowEmployeesAPI(user));

            } else if (res.type === 'corporateAddEmployeeAPI/rejected') {
                errorHandler(res.payload.errors);
            } else {
                toast.error('Sorry, something went wrong!');
            }
        },
    });
    ///////////////////////////////////ADD EMPLOYEE FORM LOGIC HERE/////////////////////////////////////////


    const options = services?.map((item) => ({
        value: item.label,
        label: item.label,
    }));


    return (
        <>
            <ToastContainer />
            <DashboardLayout>
                <div className="add-employee-box">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-7">
                                <div className="employee-form-box">
                                    <h1>Add Employee</h1>
                                    <h2>Basic Information:</h2>
                                </div>

                                <form onSubmit={formik.handleSubmit}>

                                    <div className="form-box-inputs custom-input-box flex-column">
                                        <input
                                            type="text"
                                            placeholder="Full Name"
                                            name="name"
                                            value={formik?.values?.name}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        />
                                        {formik.touched.name && formik.errors.name && (
                                            <div className="error">{formik.errors.name}</div>
                                        )}
                                    </div>

                                    <div className="form-box-inputs custom-input-box flex-column">
                                        <input
                                            type="number"
                                            placeholder="Phone Number"
                                            name="phone_no"
                                            value={formik?.values?.phone_no}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        />
                                        {formik.touched.phone_no && formik.errors.phone_no && (
                                            <div className="error">{formik.errors.phone_no}</div>
                                        )}
                                    </div>

                                    <div className="form-box-inputs custom-input-box flex-column">
                                        <input
                                            type="number"
                                            placeholder="Social Security Number"
                                            name="ss_number"
                                            value={formik?.values?.ss_number}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        />
                                        {formik.touched.ss_number && formik.errors.ss_number && (
                                            <div className="error">{formik.errors.ss_number}</div>
                                        )}
                                    </div>

                                    <div className="mb-3 custom-input-box">
                                        <input
                                            type="email"
                                            placeholder="Email Address"
                                            name="email"
                                            value={formik?.values?.email}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        />
                                        {formik.touched.email && formik.errors.email && (
                                            <div className="error">{formik.errors.email}</div>
                                        )}
                                    </div>

                                    <div className="mb-3 custom-input-box">
                                        <input
                                            type={passwordVisible ? 'text' : 'password'}
                                            placeholder="Password"
                                            name="password"
                                            value={formik?.values?.password}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        />
                                        <i
                                            className={`fa-solid ${passwordVisible ? 'fa-eye-slash' : 'fa-eye'}`}
                                            onClick={togglePasswordVisibility}
                                            style={{ cursor: 'pointer' }}
                                        ></i>

                                        {formik.touched.password && formik.errors.password && (
                                            <div className="error">{formik.errors.password}</div>
                                        )}
                                    </div>

                                    <div className="mb-3 custom-input-box">
                                        <input
                                            type={confirmPasswordVisible ? 'text' : 'password'}
                                            placeholder="Confirm Password"
                                            name="confirm_password"
                                            value={formik?.values?.confirm_password}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        />
                                        <i
                                            className={`fa-solid ${confirmPasswordVisible ? 'fa-eye-slash' : 'fa-eye'}`}
                                            onClick={toggleConfirmPasswordVisibility}
                                            style={{ cursor: 'pointer' }}
                                        ></i>

                                        {formik.touched.confirm_password && formik.errors.confirm_password && (
                                            <div className="error">{formik.errors.confirm_password}</div>
                                        )}
                                    </div>

                                    <div className="mb-3 custom-input-box">
                                        <GoogelMapAPI setGetLocationAttributes={setGetLocationAttributes} />
                                    </div>

                                    <div className="mb-3 custom-input-box">
                                        <textarea
                                            placeholder="About Employee"
                                            name="about"
                                            value={formik?.values?.about}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            className='w-100'
                                        ></textarea>
                                        {formik.touched.about && formik.errors.about && (
                                            <div className="error">{formik.errors.about}</div>
                                        )}
                                    </div>

                                    <div className="logo-box">
                                        <h3 className="second-text-heading mb-3">Add Services</h3>

                                        <span
                                            className="add-services-button"
                                            data-bs-toggle="modal"
                                            href="#exampleModalToggle"
                                            role="button"
                                        >
                                            Add Services <i className="fa-solid fa-plus"></i>
                                        </span>

                                        <div className="services-array-box">
                                            {
                                                showLoading ? (
                                                    <i style={{ fontSize: "22px" }} className="fa-solid fa-spinner fa-spin spiner-loading-icon"></i>
                                                ) : (
                                                    formArray.map((item, index) => (
                                                        <div className="selected-service" key={index}>
                                                            <span>
                                                                {item.name}
                                                                <i onClick={() => handleDeleteService(index)} className="fas fa-trash delete-icon"></i>
                                                            </span>
                                                        </div>
                                                    ))
                                                )
                                            }
                                        </div>
                                    </div>

                                    <div className="flex-center-box mb-5">

                                        <div className="logo-box">
                                            <h3 className="second-text-heading mt-2">Profile Picture</h3>
                                            <label htmlFor="upload-image" className="upload-image">
                                                <span className="bg-white">Upload Image</span>
                                            </label>
                                            <input
                                                type="file"
                                                className="d-none"
                                                id="upload-image"
                                                accept="image/*"
                                                name="profile"
                                                onChange={handleImageChange}
                                            />
                                            {formik.touched.profile && formik.errors.profile && (
                                                <div className="error">{formik.errors.profile}</div>
                                            )}
                                        </div>

                                        <div className="logo-box">
                                            <h3 className="second-text-heading mt-2">Attached Document</h3>
                                            {formik?.values?.other?.name && <p style={{ wordBreak: "break-all" }}><strong>Document Name:</strong> {formik?.values?.other?.name}</p>}
                                            <label htmlFor="upload-image-2" className="upload-image">
                                                <span className="bg-white">Upload Image</span>
                                            </label>
                                            <input
                                                type="file"
                                                className="d-none"
                                                id="upload-image-2"
                                                accept=".pdf,.doc,.docx"
                                                name='other'
                                                onChange={(e) => {
                                                    const file = e.currentTarget.files[0];
                                                    formik.setFieldValue('other', file);
                                                }}
                                            />
                                            {formik.touched.other && formik.errors.other && (
                                                <div className="error">{formik.errors.other}</div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="submit-btn-form">
                                        <button type="submit" disabled={Employeeloading || loading} className="btn btn-primary">
                                            {Employeeloading || loading ? (
                                                <i style={{ fontSize: "22px" }} className="fa-solid fa-spinner fa-spin"></i>
                                            ) : "Proceed"}
                                        </button>
                                    </div>
                                </form>

                            </div>

                            <div className="col-md-5">
                                <div className="profile-image">
                                    {imagePreview ? (
                                        <img src={imagePreview} alt="Uploaded Preview" className="uploaded-image" />
                                    ) : (
                                        <i className="fa-solid fa-user dummy-user-icon"></i>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </DashboardLayout>


            {/*********************MODELS HERE************************/}
            <div className="modal fade" data-bs-backdrop="static" id="exampleModalToggle" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabIndex={-1}>
                <div className="modal-dialog modal-dialog-centered service-add-model">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="btn-close" id='close-btn-services' data-bs-dismiss="modal" aria-label="Close"><i className="fa-solid fa-xmark"></i></button>
                        </div>

                        <div className="modal-body">
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-12">
                                        <form onSubmit={handleServicesSubmit}>
                                            <div className="employee-form-box">
                                                <h2>Add Service:</h2>
                                            </div>

                                            {/* Service Dropdown */}
                                            {/* <div className="add-service-box">
                                                <div className="add-service-input custom-input-box">
                                                    <select
                                                        name="name"
                                                        className="add-service-control"
                                                        value={formData.name}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="" disabled>Select Service</option>
                                                        {services?.map((item, index) => {
                                                            return <option value={item?.label} key={index}>{item?.label}</option>
                                                        })}
                                                    </select>
                                                </div>
                                            </div> */}

                                            <div className="professional-class-box">
                                                <Select
                                                    className="add-service-control"
                                                    options={options}
                                                    onChange={(selectedOption) =>
                                                        setFormData({ ...formData, name: selectedOption?.value })
                                                    }
                                                    value={options.find((option) => option.value === formData.name)}
                                                    isSearchable
                                                    placeholder="Select a service"
                                                />
                                            </div>

                                            {/* Select Currency Dropdown */}
                                            <div className="add-service-box custom-input-box">
                                                <label htmlFor="currency-select">Select Currency:</label>
                                                <select
                                                    name="currency"
                                                    id="currency-select"
                                                    className="form-control add-service-control"
                                                    value={formData.currency}
                                                    onChange={handleChange}
                                                >
                                                    <option value="" disabled selected>Select Currency</option>
                                                    <option value="USD">USD</option>
                                                    <option value="POUND">POUND</option>
                                                    <option value="PKR">PKR</option>
                                                </select>
                                            </div>

                                            {/* Price Input */}
                                            <div>
                                                <h3 className="form-sub-heading">Price per hour:</h3>
                                                <div className="price-service-box">
                                                    <div className="add-service-input custom-input-box">
                                                        <span className="currency-symbol">
                                                            {formData.currency === 'USD' ? '$' : formData.currency === 'POUND' ? '£' : '₨'}
                                                        </span>
                                                        <input
                                                            type="number"
                                                            className="price-input"
                                                            name="price"
                                                            value={formData.price}
                                                            onChange={handleChange}
                                                            placeholder="Enter custom price"
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Submit Button */}
                                            <div className="submit-btn-form justify-content-end mb-4 mt-4">
                                                <button type="submit" disabled={loading || !isFormValid()} className="btn btn-primary">
                                                    {loading ? (
                                                        <i style={{ fontSize: "22px" }} className="fa-solid fa-spinner fa-spin"></i>
                                                    ) : "Save"}
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/*********************MODELS HERE************************/}
        </>
    )
}

export default AddEmploye